import { createEventSender, Environment } from '@spotify-internal/event-sender';
import {
  createApplicationContext,
  createClientIdContext,
  createCorrelationIdContext,
  createUserAgentContext,
} from '@spotify-internal/event-sender/es5/contexts';

import { SUPPORT_SITE_CLIENT_ID } from 'utils/config';

import { transport } from './transport';
import getSptCookie from './getSptCookie';

function getContext() {
  const context = [
    createCorrelationIdContext(getSptCookie()),
    createClientIdContext(SUPPORT_SITE_CLIENT_ID),
    createApplicationContext({ version: '1.0.0' }), // TODO: Switch to git commit hash
  ];
  if (process.browser) {
    // user agent should only be set in the browser
    return [...context, createUserAgentContext()];
  }
  return context;
}

export const eventSender = createEventSender<Environment.BROWSER>({
  transport,
  context: getContext(),
});
